import BaseComponent from "@js/components/base_component.jsx";

import MuiAlertCriteria from "@js/components/mui/alerts/criteria.jsx";

class MuiAlertsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      frequency_mode: props.entity.frequency_mode,
      notify_all: props.entity.notify_all,
      alert_criterias: props.entity.alert_criterias,
    };
  }

  render() {
    return (
      <div>
        <ErrorBanner entity={ this.props.entity } />

        <Panel heading="alert_details">
          <div className="form-horizontal">

            <InputField
              object={ this.props.entity }
              type="mui_alert"
              field="name"
              editing={ this.props.editing }
            />

          </div>
        </Panel>

        <Panel heading="alert_criteria">
          <div className="form-horizontal">
            {
              this.state.alert_criterias.map((criteria, ii) => (
                <MuiAlertCriteria
                  entity={ criteria }
                  index={ ii }
                  is_last_criteria={ this.state.alert_criterias.length == ii+1 }
                  editing={ this.props.editing }
                  key={ ii }
                  isp_options={ this.props.isp_options }
                  isp_group_options={ this.props.isp_group_options }
                />
              ))
            }
          </div>

          <div className="text-right">
            {
              this.props.editing && (
                <ButtonAdd
                  onClick={ this._appendNewCriteria }
                  tabIndex="-1"
                  tooltip="mui_alert_criteria__add_criteria"
                >
                  Add Criteria
                </ButtonAdd>
              )
            }
          </div>
        </Panel>

        <Panel heading="alert_frequency">
          <div className="form-horizontal">
            <SelectField
              field="mui_alert.frequency_mode"
              blank="mui_alert_frequency_mode"
              value={ this.props.entity.frequency_mode }
              options={ [ { "value": "daily", "label": "Daily" }, { "value": "x_hours_after_campaign_starts", "label": "After Campaign Starts" } ] }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.frequency_mode : null }
              onChange={ (e) => this.setState({ frequency_mode: e.target.value }) }
            />

            {
              this.state.frequency_mode == "daily" && (
                <SelectField
                  field="mui_alert.frequency_daily_evaluate_at_hour"
                  blank="mui_alert_frequency_daily_evaluate_at_hour"
                  value={ this.props.entity.frequency_daily_evaluate_at_hour }
                  options={ this._dailyHourOptions() }
                  editing={ this.props.editing }
                  error={ this.props.entity.errors ? this.props.entity.errors.frequency_daily_evaluate_at_hour : null }
                />
              )
            }

            {
              this.state.frequency_mode == "daily" && (
                <SelectField
                  field="mui_alert.frequency_daily_require_campaign_sent_at_least_x_hours_ago"
                  blank="mui_alert_frequency_daily_require_campaign_sent_at_least_x_hours_ago"
                  value={ this.props.entity.frequency_daily_require_campaign_sent_at_least_x_hours_ago }
                  options={ this._hourOffsetOptions() }
                  editing={ this.props.editing }
                  error={ this.props.entity.errors ? this.props.entity.errors.frequency_daily_require_campaign_sent_at_least_x_hours_ago : null }
                />
              )
            }

            {
              this.state.frequency_mode == "x_hours_after_campaign_starts" && (
                <SelectField
                  field="mui_alert.frequency_evaluate_when_campaign_is_x_hours_old"
                  blank="mui_alert_frequency_evaluate_when_campaign_is_x_hours_old"
                  value={ this.props.entity.frequency_evaluate_when_campaign_is_x_hours_old }
                  options={ this._hourOffsetOptions() }
                  editing={ this.props.editing }
                  error={ this.props.entity.errors ? this.props.entity.errors.frequency_evaluate_when_campaign_is_x_hours_old : null }
                />
              )
            }
          </div>
        </Panel>

        <Panel heading="alert_recipients">
          <div className="form-horizontal">
            <CheckboxField
              label={ I18n.t("phrases.mui_alert_notify_all") }
              onChange={ (val) => this.setState({ notify_all: !!val }) }
              editing={ this.props.editing }
              name="mui_alert[notify_all]"
              checked={ this.state.notify_all }
            />

            <InputField
              object={ this.props.entity }
              type="mui_alert"
              field="notify_specific_addresses"
              editing={ this.props.editing }
              multiline={ true }
            />
          </div>
        </Panel>
      </div>
    );
  }

  _dailyHourOptions() {
    return [
      [  0, "12am" ],
      [  1,  "1am" ],
      [  2,  "2am" ],
      [  3,  "3am" ],
      [  4,  "4am" ],
      [  5,  "5am" ],
      [  6,  "6am" ],
      [  7,  "7am" ],
      [  8,  "8am" ],
      [  9,  "9am" ],
      [ 10, "10am" ],
      [ 11, "11am" ],
      [ 12, "12pm" ],
      [ 13,  "1pm" ],
      [ 14,  "2pm" ],
      [ 15,  "3pm" ],
      [ 16,  "4pm" ],
      [ 17,  "5pm" ],
      [ 18,  "6pm" ],
      [ 19,  "7pm" ],
      [ 20,  "8pm" ],
      [ 21,  "9pm" ],
      [ 22, "10pm" ],
      [ 23, "11pm" ],
    ].map((hour) => (
      {
        "value": hour[0],
        "label": hour[1],
      }
    ));
  }

  _hourOffsetOptions() {
    return [
      [  1,  "1 hour ago"  ],
      [  2,  "2 hours ago" ],
      [  3,  "3 hours ago" ],
      [  4,  "4 hours ago" ],
      [  5,  "5 hours ago" ],
      [  6,  "6 hours ago" ],
      [  7,  "7 hours ago" ],
      [  8,  "8 hours ago" ],
      [  9,  "9 hours ago" ],
      [ 10, "10 hours ago" ],
      [ 11, "11 hours ago" ],
      [ 12, "12 hours ago" ],
      [ 13,  "1 hours ago" ],
      [ 14,  "2 hours ago" ],
      [ 15,  "3 hours ago" ],
      [ 16,  "4 hours ago" ],
      [ 17,  "5 hours ago" ],
      [ 18,  "6 hours ago" ],
      [ 19,  "7 hours ago" ],
      [ 20,  "8 hours ago" ],
      [ 21,  "9 hours ago" ],
      [ 22, "10 hours ago" ],
      [ 23, "11 hours ago" ],
    ].map((hour) => (
      {
        "value": hour[0],
        "label": "Campaign started at least " + hour[1],
      }
    ));
  }

  _appendNewCriteria() {
    this.setState({ alert_criterias: this.state.alert_criterias.concat([ {} ]) });
    return true;
  }

}

export default MuiAlertsForm;
